import { SetStateAction } from "react";
import { DateTime } from "luxon";
import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";
import { calculateMaxEndDate } from "../../../BookingForm/utils/booking.utils";
import { ValidMaxAdvancedPerType } from "../../../BookingForm/form-selection-bookingType.component";
import { MetaData } from "../../../../features/Login/typings/login.types";

function parseEndDateTime(end: DateTime, endTime: string): DateTime {
  const time = endTime && typeof endTime === "string" ? endTime : "00:00";
  const [hourStr, minuteStr] = time.split(":");
  const hour = Number(hourStr) || 0;
  const minute = Number(minuteStr) || 0;
  return end.set({ hour, minute, second: 0, millisecond: 0 });
}

export function handleValidMaxAdvancedPerBookingType({
  end,
  endTime,
  metaData,
  setValidMaxAdvancedPerType
}: {
  end: DateTime;
  endTime: string;
  metaData: MetaData;
  setValidMaxAdvancedPerType: (value: SetStateAction<ValidMaxAdvancedPerType>) => void;
}) {
  const selectedEndDateTime = parseEndDateTime(end, endTime);

  const maxDateTimeWp = DateTime.fromISO(
    calculateMaxEndDate({ metaData, bookingMode: BookingType.WORKPLACE })
  );
  const maxDateTimePark = DateTime.fromISO(
    calculateMaxEndDate({ metaData, bookingMode: BookingType.PARKINGPLACE })
  );
  const maxDateTimeElec = DateTime.fromISO(
    calculateMaxEndDate({ metaData, bookingMode: BookingType.ELECTRICCHARGINGSTATIONPLACE })
  );
  const maxDateTimeConf = DateTime.fromISO(
    calculateMaxEndDate({ metaData, bookingMode: BookingType.CONFERENCEZONE })
  );
  const maxAdvancedDateVehi = DateTime.fromISO(
    calculateMaxEndDate({ metaData, bookingMode: BookingType.VEHICLE })
  );
  const maxDateTimeVisitor = DateTime.fromISO(
    calculateMaxEndDate({ metaData, bookingMode: BookingType.VISITOR })
  );

  setValidMaxAdvancedPerType({
    workplace: maxDateTimeWp.isValid && maxDateTimeWp >= selectedEndDateTime,
    parkingplace: maxDateTimePark.isValid && maxDateTimePark >= selectedEndDateTime,
    electriccharging: maxDateTimeElec.isValid && maxDateTimeElec >= selectedEndDateTime,
    conference: maxDateTimeConf.isValid && maxDateTimeConf >= selectedEndDateTime,
    vehicle: maxAdvancedDateVehi.isValid && maxAdvancedDateVehi >= selectedEndDateTime,
    visitor: maxDateTimeVisitor.isValid && maxDateTimeVisitor >= selectedEndDateTime
  });
}
